import React, { Suspense, useEffect, useRef } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
export function usePrevious(value, defaultPrevious = null) {
    const ref = useRef(defaultPrevious);

    useEffect(() => {
        ref.current = value;
    }, [value]);

    return ref.current;
}

export function useOnNewListItem({ disabled, itemList, callback }) {
    const prevList = usePrevious(itemList) || [];
    const hasNewItem = itemList.length > prevList.length;
    const hasCleared = itemList.length < prevList.length;

    useEffect(
        function reactOnNewItem() {
            if (!disabled) {
                if (hasNewItem) {
                    callback(false);
                } else if (hasCleared) {
                    callback(true);
                }
            }
        },
        [disabled, hasNewItem, callback, hasCleared]
    );
}

/*
! Warning: Should be used if you are returning a new object inside your selector
! WARNING: You should not be doing that already as that is an anti-pattern, this is just in case if you cannot avoid
! it
*/
export function useShallowEqualSelector(selector) {
    return useSelector(selector, shallowEqual);
}

export const LazyLoaded = (Component, fallback) => (props) => (
    <Suspense fallback={fallback || <></>}>
        <Component {...props} />
    </Suspense>
);
